const EpiappEvent = require('./EpiappEvent')

class EpiappActivationEvent extends EpiappEvent {
    constructor (props) {
        super(props)

        this.type = EpiappActivationEvent.TYPE

        this.apiGatewayStage = props.apiGatewayStage
        this.apiGatewayRequestId = props.apiGatewayRequestId

        this.requestHost = props.requestHost
        this.requestPath = props.requestPath
        this.requestResourcePath = props.requestResourcePath
        this.requestMethod = props.requestMethod

        this.accountId = props.accountId
        this.userId = props.userId
        
        this.authenticated = props.authenticated
        if (!this.authenticated) {
            this.authenticated = false
        }

        this.authAccountId = props.authAccountId
        this.authUserId = props.authUserId

        this.activationToken = props.activationToken

        this.activationPassed = props.passed

        
    }
}

EpiappActivationEvent.TYPE = 'epi:epiapp:activation:event'

module.exports = EpiappActivationEvent
